module.exports = __webpack_public_path__ + "static/media/licenta9.819ab85e.png";